// export default class URIUtil {
//     static appendParams(uri, params) {
//         if (uri && typeof params === 'object') {
//             let paramsStr = Object.entries(params).map(item => {
//                 let value = item[1] && item[1].toString();
//                 return item[0] + '=' + (value ? encodeURIComponent(value) : '')
//             }).join("&")
//             if (paramsStr && paramsStr.length > 0) {
//                 uri += (uri.search(/\?/) < 0 ? '?' : '&') + paramsStr
//             }
//         }
//         return uri
//     }
//     static parseParams(uri) {
//         var parse = uri.substring(uri.indexOf("?") + 1),
//             params = parse.split("&"),
//             len = params.length,
//             item = [],
//             param = {};
//
//         for (var i = 0; i < len; i++) {
//             item = params[i].split("=");
//             param[item[0]] = item[1];
//         }
//
//         return param;
//     }
// }
export default class URIUtil {
    static appendParams(uri, params = {}) {
        let needReplace = false;
        if (!uri || !uri.startsWith('http')) {
            uri = window.location.origin + uri;
            needReplace = true;
        }
        const urlObj = new URL(uri);
        Object.keys(params || {}).forEach(key => {
            let value = params[key];
            if (value === null || value === undefined) {
                value = '';
            }
            urlObj.searchParams.append(key, value)
        });
        if (needReplace) {
            return urlObj.toString().replace(window.location.origin, '');
        }
        return urlObj.toString();
    }

    static parseParams(uri) {
        if (!uri || !uri.startsWith('http')) {
            uri = window.location.origin + uri;
        }
        let url;
        try {
            url = new URL(uri);
        } catch (e) {
            url = new URL(decodeURIComponent(uri));
        }
        const params = new URLSearchParams(url.search);
        const result = {};
        for (const key of params.keys()) {
            result[key] = params.get(key)
        }
        return result;
    }
}